<script>
  import { onDestroy } from 'svelte';
  import { fade } from 'svelte/transition';
  import {
    listenToChatPreview,
    listenToChatPublished,
    changeChannelStatus,
    listenToChannel,
  } from '../../../Api/api';
  import Button from '../../Common/Button.svelte';
  import AnswerInput from './AnswerInput.svelte';
  import CommentList from './CommentList.svelte';
  import { selectedChannelId, singleChatId, selectedCategory } from '../../../Store/store';
  import { navigate } from 'svelte-routing';
  import History from '../Moderator/History.svelte';
  import { isAfter } from '../../../common/dates';

  export let id = '';
  export let minWidth640 = true;

  let unsubscribeListenToChat;
  let unsubscribeListenToChannel;
  let thread = [];

  $: selectedComment = null;
  $: selectedCommentId = '';

  let currentId = '';
  let showHistory = false;
  let threadHistory = [];

  $: channel = null;
  $: id && listenToChannelData(id);
  $: id && listenToNewChatData(id);

  onDestroy(async () => {
    if (unsubscribeListenToChat) {
      unsubscribeListenToChat();
    }
    if (unsubscribeListenToChannel) {
      unsubscribeListenToChannel();
    }
  });

  const listenToChannelData = async (channelId) => {
    if (unsubscribeListenToChannel) {
      unsubscribeListenToChannel();
      unsubscribeListenToChannel = null;
    }
    unsubscribeListenToChannel = await listenToChannel(channelId, (snapShot) => {
      if (snapShot.exists) {
        channel = { ...snapShot.data(), id: snapShot.id };
      }
    });
  };

  const chatSnapshotCallback = (snapShot) => {
    const chatData = [];
    snapShot.forEach((doc) => {
      chatData.push({ ...doc.data(), commentId: doc.id });
    });
    thread = chatData
      .filter((c) => !c.answered && !c.d && !c.blocked && !c.ignore && !c.m)
      .reverse();
    threadHistory = chatData
      .filter((c) => !!c.created && (c.a || c.d))
      .sort((a, b) => {
        isAfter(b.created.toDate(), a.created.toDate()) ? 1 : -1;
      });

    if ($selectedCategory === 'multichannel') {
      thread = thread.filter((c) => !c.a);
    }

    const selectedCommentTest = thread.filter((t) => t.commentId === selectedCommentId);
    if (!selectedCommentTest.length) {
      selectedCommentId = '';
      selectedComment = null;
    } else {
      selectedCommentId = selectedCommentTest[0].commentId;
      selectedComment = selectedCommentTest[0];
    }
  };

  const listenToNewChatData = async (channelId) => {
    if (channelId !== currentId) {
      if (unsubscribeListenToChat) {
        unsubscribeListenToChat();
        unsubscribeListenToChat = null;
      }
      currentId = channelId;
      if ($singleChatId || $selectedCategory === 'multichannel') {
        unsubscribeListenToChat = await listenToChatPublished(channelId, (snapShot) =>
          chatSnapshotCallback(snapShot),
        );
      } else {
        unsubscribeListenToChat = await listenToChatPreview(channelId, (snapShot) =>
          chatSnapshotCallback(snapShot),
        );
      }
    }
  };

  const onAnswerSelected = (e) => {
    selectedCommentId = e.detail.commentId;
    selectedComment = e.detail;
  };

  const onShowHistory = () => {
    showHistory = !showHistory;
  };

  const onBackBtnClicked = (e) => {
    selectedCommentId = '';
    selectedComment = null;
  };

  const onGoLiveClicked = async (e, channel) => {
    e.stopPropagation();
    await changeChannelStatus(channel.id, !channel.live);
  };
</script>

<div class="moderator-container">
  <div class="header">
    <button class="backBtn" on:click={() => navigate('/chat')}
      ><span class="material-icons"> west </span></button
    >
    {#if channel}
      <h3>{channel.name}</h3>
      {#if !$singleChatId}
        <div class="btn-container">
          <Button
            on:click={(e) => onGoLiveClicked(e, channel)}
            big={true}
            disabled={channel?.archived}
            red={channel.live}
          >
            {channel.live ? 'Steng chat' : 'Start chat'}
          </Button>
        </div>
      {:else}
        <button class="show-history-btn {showHistory ? 'active' : ''}" on:click={onShowHistory}
          ><span class="material-icons"> history </span>Sendte meldinger</button
        >
      {/if}
    {/if}
  </div>

  <div class="mobile-header">
    <h3>Svar på meldinger</h3>
    {#if $singleChatId}
      <div class="buttons">
        <button class="show-history-btn {showHistory ? 'active' : ''}" on:click={onShowHistory}
          ><span class="material-icons"> history </span>Sendte meldinger</button
        >
      </div>
    {/if}
  </div>

  <div class="comments-container" in:fade>
    {#if showHistory}
      <History channelId={$selectedChannelId} history={threadHistory} on:close={onShowHistory} />
    {:else if minWidth640}
      <CommentList {thread} {selectedCommentId} channelId={id} on:selected={onAnswerSelected} />
      <div class="answer-container">
        <AnswerInput channelId={id} comment={selectedComment} />
      </div>
    {:else if !selectedCommentId}
      <CommentList {thread} {selectedChannelId} channelId={id} on:selected={onAnswerSelected} />
    {:else}
      <AnswerInput channelId={id} comment={selectedComment} on:bckbtnclicked={onBackBtnClicked} />
    {/if}
  </div>
</div>

<style src="./adminChat.scss">
</style>
